import { render, staticRenderFns } from "./XNestableHandle.vue?vue&type=template&id=4e78c72f&"
import script from "./XNestableHandle.vue?vue&type=script&lang=js&"
export * from "./XNestableHandle.vue?vue&type=script&lang=js&"
import style0 from "./XNestableHandle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports